import React from 'react';
import './ACDCToggle.css';

interface ACDCToggleProps {
	selected:  string;
	onChange?: (value: 'AC' | 'DC') => void;
}

const ACDCToggle: React.FC<ACDCToggleProps> = ({ selected, onChange }) => {
	return (
		<div className='chargers-type-toggle-container'>

			<div
				className='dc-toggle-btn'
				style={{
					backgroundColor: selected === 'DC' ? '#06BFBF' : 'transparent',
					color: selected === 'DC' ? '#ffffff' : '#666666',
					cursor: 'pointer',
					transition: 'all 0.3s ease'
				}}
				onClick={() => onChange?.('DC')}
			>
				DC
			</div>
						<div
				className='ac-toggle-btn'
				style={{
					backgroundColor: selected === 'AC' ? '#06BFBF' : 'transparent',
					color: selected === 'AC' ? '#ffffff' : '#666666',
					cursor: 'pointer',

					transition: 'all 0.3s ease'
				}}
				onClick={() => onChange?.('AC')}
			>
				AC
			</div>
		</div>
	);
};

export default ACDCToggle;
